module.exports = __webpack_public_path__ + "static/img/frederique.fb17247.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/frederique.jpg
// module id = 3
// module chunks = 0